import React, { useEffect, useState } from 'react';
import axios from "../../../common/axios";
import CircularLoader from "../../../common/CircularLoader";
import MathJaxHTMLContent from "../../../common/MathJaxHTMLContent";

const PreviewTest = ({ testAssignmentId }) => {
    const [loading, setLoading] = useState(true);
    const [htmlContent, setHtmlContent] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        if(testAssignmentId == undefined) {
            return;
        }

        const fetchPreview = async () => {
            try {
                const response = await axios.get(`/controlCentre/showStudentTestPreview.action`, {
                    params: { testAssignmentId }
                });
                setHtmlContent(response.data);
            } catch (err) {
                console.error('Error fetching test preview:', err);
                setError('Failed to load test preview.');
            } finally {
                setLoading(false);
            }
        };

        fetchPreview();
    }, [testAssignmentId]);

    if (loading) {
        return <CircularLoader pageCentered={true} />;
    }

    if (error) {
        return <div className="ch-content-error">{error}</div>;
    }

    return (
        <div style={{maxHeight: '500px', overflowY: 'auto'}}>
            <MathJaxHTMLContent html={htmlContent}/>
        </div>
    );
};

export default PreviewTest;
